import { FC, ReactElement } from 'react'
import classnames from 'classnames'

import { getImageSource } from './helpers/getImageSource'

import './MaterialIcon.scss'

interface MaterialIconProps {
    kind: string
    inline?: boolean
    className?: string
    color?: string
    fontSize?: number
}

// Shows one of the own svg icons when one exists for `kind`, otherwise the Material icon with that name
export const MaterialIcon: FC<MaterialIconProps> = ({
    kind,
    inline = false,
    className = '',
    color,
    fontSize = 24,
}): ReactElement => {
    const image = getImageSource(kind)
    const materialClassNames = classnames('material-icons icon', {
        'icon--inline': inline,
        [`text-${color}`]: color,
    }, [className])

    if (image) {
        return (
            <img
                className={`icon-img ${className}`}
                alt="icon"
                style={{ width: `${fontSize}px` }}
                src={image}
            />
        )
    }

    return (
        <i
            className={materialClassNames}
            style={{ fontSize }}
        >
            { kind }
        </i>
    )
}
